const currentMessage = (state = "", action) => {
    switch (action.type) {
        case 'UPDATE_MESSAGE':
            return action.message;
        case 'ADD_MESSAGE':
            return "";
        case 'DELETE_MESSAGES':
        	return "";
        default:
            return state;
    }
}

export default currentMessage;


// WEBPACK FOOTER //
// ./src/reducers/current-message.js